<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <ul class="breadcrumb">
        <li>
          <router-link :to="{ name: 'ManageTracking'}">{{'Manage tracking'|translate}}</router-link>
        </li>
        <li>{{'Manage blocks'|translate}}</li>
      </ul>

      <h3>{{'Manage Blocks'|translate}}</h3>
      <div class="row">
        <div class="col-md-5 mt20">
          <a class="btn btn-primary" v-on:click="showModal(null)">{{'Add block'|translate}}</a>
        </div>
        <div class="col-md-7 mt20">
          <input
            type="text"
            class="form-control"
            v-model="keyword"
            v-on:keypress.enter.prevent="search()"
            :placeholder="'Search'|translate"
          />
        </div>
      </div>

      <loading v-if="list_items == null" class="mt20" :text="'Please wait'|translate"></loading>

      <p class="mt10" v-if="list_items && list_items.length == 0">{{'There is no data'|translate}}</p>
      <table class="table mt10" v-if="list_items && list_items.length > 0">
        <thead>
          <tr>
            <th>{{'Name'|translate}}</th>
            <th>{{'Count Periods'|translate}}</th>

            <th>{{'Area'|translate}}</th>

            <th>{{'Garden name'|translate}}</th>
            <th>{{'Action'|translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item) in list_items" :key="item.id">
            <td>
              <router-link
                :to="{ name: 'ManagePeriod', params: { block_id: item.id }}"
              >{{item.name}}</router-link>
            </td>

            <td>{{ item.count_periods }}</td>
            <td>{{ item.area }}</td>
            <td>{{ item.garden_name }}</td>
            <td>
              <a
                class="btn btn-danger"
                v-on:click="removeItem(item)"
                :disabled="removing"
              >{{'Delete'|translate}}</a>

              <a
                class="btn btn-info"
                v-bind:class="{disabled:item.remain_text == 0}"
                v-on:click="showModal(item)"
              >
                {{'Update'|translate}}
                <span v-if="item.remain_text != 0">[{{item.remain_text}}]</span>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <paginate
        v-if="total_page > 1"
        :page-count="total_page"
        :click-handler="clickPage"
        :prev-text="'Prev'|translate"
        :next-text="'Next'|translate"
        v-model="page"
        :container-class="'pagination'"
      ></paginate>

      <form-block
        v-if="show_form_block"
        ref="formblock"
        :gardens="gardens"
        :pass_data="pass_data"
        @modalData="modalData"
      ></form-block>
    </div>
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import FormBlock from "@/components/Cultivation/FormBlock";
import Paginate from "vuejs-paginate";
import Loading from "@/components/elements/Loading";
export default {
  name: "ManageTracking",
  components: {
    MyHeader,
    FormBlock,
    Paginate,
    Loading
  },
  data() {
    return {
      show_form_block: false,
      gardens: [],
      pass_data: null,
      list_items: null,
      removing: false,
      page: 1,
      offset: 0,
      keyword: "",
      limit: Utils.getLimit(),
      total_page: 1,
      select_tab: "manage_tracking"
    };
  },
  methods: {
    modalData(data) {

      this.list();
    },
    showModal(data) {
      this.show_form_block = true;

      this.pass_data = data != null ? JSON.parse(JSON.stringify(data)) : data;

      setTimeout(() => {
        this.$refs.formblock.open();
      });
    },
    list() {
      let data = {
        offset: this.offset,
        limit: this.limit,
        keyword: this.keyword
      };
      
      Utils.request(this, true, "land")
        .get(`/manageBlock/?${Utils.arrayToRequestParam(data)}`)
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            let list = data.data.list;
            list = list.map(item => {
              let temp = new Date(parseInt(item.add_time) * 1000);
              item.add_date = this.$moment(temp);
              item.remain_text = Utils.getFormattedTime(this, item.add_date);
              return item;
            });
            this.list_items = list;
            // console.log("data.data.total", data.data.total);
            this.total_page = Utils.getTotalPages(data.data.count);
            // console.log("this.total_page", this.total_page);
            // update local storage
          }
        });
      // .catch(error => {
      //     this.updating = false
      //     Utils.showErrorMessage(this, error.response)
      // })
    },
    removeItem(item) {
      this.$alertify.confirmWithTitle(
        this.$t("Confirm"),
        this.$t("Are you sure to remove this item ?"),
        () => {
          this.removing = true;
          Utils.request(this, true, "land")
            .delete(`/manageBlock/${item.id}`)
            .then(response => {
              this.removing = false;
              let data = response.data;
              if (data.status === "ok") {
                this.offset = 0;
                this.list();
              } else {
                Utils.showError(this, data.data);
              }
            });
        }
      );
    },
    clickPage(pageNum) {
      
      this.offset = Utils.getNextOffset(pageNum);
      this.list();
    },
    search() {
      
      this.offset = 0;
      this.list();
    },
    getListGarden() {
      let data = {
        offset: 0,
        limit: -1
      };

      Utils.request(this, true, "garden")
        .get(`/manageGarden/?${Utils.arrayToRequestParam(data)}`)
        .then(response => {
          this.gardens = response.data.data.list;
          
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    }
  },
  mounted() {
    this.list();
    this.getListGarden();
    this.$options.interval = setInterval(() => {
      Utils.updateDateTime(this);
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Cultivation/ManageBlock.vue